import React from 'react';
import styled from '@emotion/styled';
import { IIframeProps } from './IIframeProps';
import { IframeWrap } from './IframeWrap';
import { Responsive } from '../../utils';

export const StyledIframe = styled.iframe<{
	maxHeight?: number;
	maxWidth?: number;
}>`
	max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : '100%')};
	max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '100%')};
	width: 100%;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		max-height: 100%;
	}
`;

export function ResponsiveIframe({
	url,
	maxWidth,
	maxHeight,
	title,
	...rest
}: IIframeProps) {
	const getCorrectUrlFormat = (embedUrl: string) => {
		const vimeoRegex =
			/^(https?:\/\/)?(www\.)?(vimeo\.com\/)([a-zA-Z0-9_]+)(\/\S*)?$/;
		const match = embedUrl.match(vimeoRegex);

		if (match) {
			const videoId = match[4];
			return `https://player.vimeo.com/video/${videoId}`;
		}

		return embedUrl;
	};

	const updatedUrl = getCorrectUrlFormat(url);

	return (
		<IframeWrap maxWidth={maxWidth} maxHeight={maxHeight}>
			<StyledIframe
				src={updatedUrl}
				{...rest}
				frameBorder="0"
				title={title}
				maxWidth={maxWidth}
				maxHeight={maxHeight}
			/>
		</IframeWrap>
	);
}
